import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { Routing } from './constants/routing';
import MainLayout from 'layout/MainLayout';
import { Spinner } from 'layout';
import Landing from 'pages/Landing';

/* Designer Pages */

/* Developer Pages */
const DesignerLanding = lazy(() => import('pages/UI/Landing'));
const Clinicians = lazy(() => import('pages/Clinicians/Clinicians'));

interface IRoute {
    path: string;
    component: React.ReactNode;
    // component: React.LazyExoticComponent<React.FC<{ any }>> | React.ReactNode;
    exact?: boolean;
    action?: string;
    page?: string;
    hideHeader?: boolean;
}

const routes: IRoute[] = [
    {
        path: Routing.DesignerLanding,
        component: <DesignerLanding />,
    },
    {
        path: Routing.Landing,
        component: <Landing />,
    },
    {
        path: Routing.Clinicians,
        component: <Clinicians />,
    },
];

const AppRouting: React.FC = () => {
    return (
        <BrowserRouter>
            <MainLayout>
                <Suspense fallback={<Spinner />}>
                    <Switch>
                        {routes.map(({ path, component }, key) => (
                            <Route exact={true} path={path} key={key} render={() => <>{component}</>} />
                        ))}
                        <Redirect to={{ pathname: Routing.Landing }} />
                    </Switch>
                </Suspense>
            </MainLayout>
        </BrowserRouter>
    );
};

export default AppRouting;
